/** @type {import("../types/mutations/sidebar").SidebarMutationKeys} */
const sidebar_mutation_keys = {
    "SET_SECTION": "SIDEBAR/SET_SECTION"
}

/** @type {import("../types/mutations/sidebar").SidebarMutations} */
const sidebar_mutations = {
    /** Setting active sidebar section. */
    [sidebar_mutation_keys.SET_SECTION]: (state, section) => state.sidebar.section = section
}

export default sidebar_mutations;

export { sidebar_mutation_keys };